module.exports = __webpack_public_path__ + "ipetbooking/admin/img/logo-dark.9cbb0fa3.svg";